import React from 'react';
import { FaLock, FaUserShield, FaInfoCircle } from 'react-icons/fa';

export const Privacy = () => {
  return (
    <div className="p-8 mt-16 max-w-4xl mx-auto bg-white rounded-lg shadow-lg">
      <h1 className="text-4xl font-extrabold mb-6 text-center text-gray-800">Privacy Policy</h1>
      <p className="text-lg text-gray-700 mb-6 text-center">We are committed to protecting your privacy. This privacy policy outlines how we handle your personal information to protect your privacy.</p>
      
      <div className="space-y-8">
        <div className="flex items-center space-x-4">
          <FaLock className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Information Collection</h2>
            <p className="text-gray-600">We collect personal information that you provide to us directly, such as when you create an account, place an order, or contact us for support.</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          <FaUserShield className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Use of Information</h2>
            <p className="text-gray-600">We use the information we collect to process your orders, provide customer support, improve our services, and communicate with you about promotions and updates.</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          <FaInfoCircle className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Information Sharing</h2>
            <p className="text-gray-600">We do not share your personal information with third parties except as necessary to provide our services, comply with the law, or protect our rights.</p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <FaLock className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Security</h2>
            <p className="text-gray-600">We implement security measures to protect your information from unauthorized access, disclosure, alteration, and destruction.</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          <FaUserShield className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Your Choices</h2>
            <p className="text-gray-600">You have the right to access, update, and delete your personal information. You can also opt-out of receiving promotional communications from us.</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          <FaInfoCircle className="text-green-500 w-8 h-8" />
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Contact Us</h2>
            <p className="text-gray-600">If you have any questions or concerns about our privacy policy, please contact us at <a href="mailto:shreejewels0904@gmail.com" className="text-green-500 underline">shreejewels0904@gmail.com</a>.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
